<template>
    <TypesList v-if="!showDetails" @edit="editType($event)" />
    <TypeDetails v-if="showDetails" :item="itemToEdit" @cancel="cancelType" @save="saveType" />
</template>

<script>
import { mapActions, mapState } from "vuex";
import TypesList from "./types/TypesList.vue";
import TypeDetails from "./types/TypeDetails.vue";
import { useFocusOnQueryField } from "@/shared/utils/forms/useFocusOnQueryField";
import { useCleanQueryParams } from "@/shared/utils/router/useCleanQueryParams";

export default {
    components: {
        TypesList,
        TypeDetails,
    },
    computed: {
        ...mapState("cookie", ["cookie"]),
    },
    setup() {
        useFocusOnQueryField();
        const { cleanQueryParams } = useCleanQueryParams();
        return { cleanQueryParams };
    },
    mounted() {
        this.$watch(() => this.$route.query.open, this.handleQueryChange, {
            immediate: true,
        });
    },
    data() {
        return {
            showDetails: false,
            itemToEdit: {},
        };
    },
    methods: {
        ...mapActions("cookie", ["saveSnapshot"]),
        ...mapActions("alert", ["showWarnMessage"]),
        editType(item) {
            this.itemToEdit = item;
            this.showDetails = true;
        },
        async saveType() {
            await this.saveSnapshot();
            this.showDetails = false;
        },
        async cancelType() {
            await this.saveSnapshot();
            this.showDetails = false;
        },
        handleQueryChange() {
            if (this.$route.query.open === "edit") {
                const type = this.$route.query.id;
                setTimeout(() => {
                    this.cleanQueryParams(["open", "id"]);
                }, 100);

                if (this.showDetails && this.itemToEdit !== type) {
                    this.showWarnMessage({
                        message: this.$t("cookie.groups.unsaved_changes"),
                    });

                    return;
                }

                this.editType(type);
            }
        },
    },
};
</script>
